import { teamCEO, teamCTO, teamCFO } from '../images/Team';

export const teamData = [
  {
    id: 1,
    name: 'Qaiser Sultan',
    title: 'Co-Founder',
    image: teamCEO,
    linkedin: 'https://www.linkedin.com/in/qaisarsultan/'
  },
  {
    id: 2,
    name: 'Faiz Uddin',
    title: 'Co-Founder',
    image: teamCTO,
    linkedin: 'https://www.linkedin.com/in/faiz-uddin-pk/'
  },
  {
    id: 3,
    name: 'Sanan Ali',
    title: 'Co-Founder',
    image: teamCFO,
    linkedin: 'https://www.linkedin.com/in/sanan-ali-'
  }
];
